import { render } from "./FuelTanks.vue?vue&type=template&id=23e807d8&scoped=true"
import script from "./FuelTanks.vue?vue&type=script&lang=js"
export * from "./FuelTanks.vue?vue&type=script&lang=js"

import "./FuelTanks.vue?vue&type=style&index=0&id=23e807d8&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e807d8"]])

export default __exports__